import SignalRService from '../WS/SignalRService';

let goalPlayerMessageHandler = null;
let goalPlayerReconnectedHandler = null;

const ConnectGoalWebSocket = async (playerId, onStatus = () => {}, onToast = () => {}) => {
  onStatus('connecting');

  goalPlayerReconnectedHandler = () => {
    onStatus('connected');
  };

  SignalRService.on('reconnected', goalPlayerReconnectedHandler);

  SignalRService.connect({ tipo: `goal:${playerId}` })
    .then(() => {
      onStatus('connected');
      onToast('Conectado');
    })
    .catch((err) => {
      console.error("[GoalWS] Error al conectar a SignalR:", err);
      onStatus('error');
    });
};

const SetGoalSocketMessageHandler = (handler) => {
  if (goalPlayerMessageHandler) {
    SignalRService.off('message', goalPlayerMessageHandler);
  }

  goalPlayerMessageHandler = (envelope) => {
    handler(envelope);
  };

  SignalRService.on('message', goalPlayerMessageHandler);
};

const ClearGoalSocketMessageHandler = () => {
  if (goalPlayerMessageHandler) {
    SignalRService.off('message', goalPlayerMessageHandler);
    goalPlayerMessageHandler = null;
  }
};

const DisconnectGoalWebSocket = () => {
  if (goalPlayerMessageHandler) {
    SignalRService.off('message', goalPlayerMessageHandler);
    goalPlayerMessageHandler = null;
  }
  if (goalPlayerReconnectedHandler) {
    SignalRService.off('reconnected', goalPlayerReconnectedHandler);
    goalPlayerReconnectedHandler = null;
  }
  SignalRService.disconnect();
};

// 📡 REST (DL muy simple aquí mismo)
const SendTaps = async ({ matchId, playerId, taps }) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}RunToGoal/add-taps`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ matchId, playerId, taps })
    });
    return { success: res.ok };
  } catch {
    return { success: false };
  }
};

export { ConnectGoalWebSocket, SetGoalSocketMessageHandler, ClearGoalSocketMessageHandler, DisconnectGoalWebSocket, SendTaps };